import { ThemeProvider } from '@emotion/react';
import { useTranslations } from 'next-intl';

import {
  ContentLayout,
  TransporterPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
  SerpOffersModule,
} from '@silvertours/front-features';
import { Theme } from '@silvertours/front-shared';

import { Body } from '../body';

const TransporterContent = ({
  content: {
    article,
    globalRating,
    introduction,
    links,
    offersByCategory,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<TransporterPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);
  const offersTranslations = useTranslations('features.offers');

  return (
    <Body
      title={primaryHeadline}
      stage={<StageLegacy.Stage content={stage.content} />}
      content={({ container, containerModule, contentModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),
        containerModule(
          'introduction-content',
          <ThemeProvider theme={Theme.defaultTheme}>
            <ContentArticle
              modules={introduction?.segments ?? []}
              translations={translations}
            />
          </ThemeProvider>,
          !!introduction?.segments,
        ),
        containerModule(
          'serpOffers',
          <ThemeProvider theme={Theme.defaultTheme}>
            {!!offersByCategory.content && (
              <SerpOffersModule
                content={offersByCategory.content}
                translations={{
                  airConditioning: offersTranslations('car.airConditioning'),
                  carTypes: t.raw('offers.car.type' as any),
                  prevText: offersTranslations('prevText'),
                  nextText: offersTranslations('nextText'),
                  searchButtonText: offersTranslations('searchButtonText'),
                  disclaimertext: offersTranslations('disclaimerSerpOffers'),
                  pricePrefix: offersTranslations('pricePrefix'),
                  priceSuffix: offersTranslations('priceSuffix'),
                  serpTitle: offersTranslations('serp.title'),
                  transmissionAutomatic: offersTranslations(
                    'car.transmissionAutomatic',
                  ),
                  transmissionManual: offersTranslations(
                    'car.transmissionManual',
                  ),
                }}
              />
            )}
          </ThemeProvider>,
          !!offersByCategory.content &&
            Object.keys(offersByCategory.content).length > 0,
        ),
        container('content-modules', [
          contentModule(
            'article',
            <ThemeProvider theme={Theme.defaultTheme}>
              <ContentArticle
                modules={article.segments}
                translations={translations}
              />
            </ThemeProvider>,
          ),
        ]),
        containerModule(
          'linkLists',
          <ThemeProvider theme={Theme.defaultTheme}>
            <ContentArticle
              modules={links.content ?? []}
              translations={translations}
            />
          </ThemeProvider>,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { TransporterContent };
